import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { saveAs as saveByFileSaver } from "file-saver";
import { WorkFlow } from '../masterdata/models/workFlow';
import { MessagesService } from '../messages/messages.service';
import { Sample } from '../models/sample';
import { ErrorHandler } from '../utils/error-handler';
import { ActivatedRoute } from '@angular/router';
import { Covid19Batch, WellType } from '../agptesting-newview/model/covid19Batch';
import { ConfirmationService } from 'primeng/api';
import { LabMDM } from '../masterdata/models/lab';
import { Comment } from '../agptesting-newview/model/comment';
import { BatchGroup } from '../agptesting-newview/model/batchGroup';
import { BatchItemHistory } from '../agptesting-newview/model/batchItemHistory';
import { CovidSamples, DilutedCovidSamples } from '../agptesting-newview/model/covid-sample';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { SelectableLab } from '../carrier/selectable-lab';
import { APGCovid19Constants } from '../agptesting-newview/model/apg-newview-constants';
import { APGTestingService } from '../agptesting-newview/apgtesting.service';
import { Tags } from '../masterdata/models/tags';
import { PlateViewComponent } from '../plate-view/plate-view.component';
import rfdc from 'rfdc';
import { Library } from '../run-planning/models/libraryDTO';
import { RunPlanningService } from '../run-planning/run-planning.service';
import { ProcessStepStage } from '../models/process-step-stages';
import { Step } from '../models/step';
import { PlateStatus, ProcessStep } from '../models/process-step';
import { Machine } from '../masterdata/models/machine';

@Component({
  selector: 'app-ngs-process',
  templateUrl: './ngs-process.component.html',
  styleUrls: ['./ngs-process.component.css']
})
export class NgsProcessComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;

  selectedLabId: string;
  puid: string;
  // table properties and values
  filterOptions: any[];
  blocked = false;
  loading: boolean;
  fromDate: Date;

  workFlowList = [];
  workFlowData: WorkFlow[] = [];
  workFlowNameList: string[] = [];

  scanDialogMessage = 'Scan RNA Plate changes not yet saved. Do you wish to proceed?';
  mapOfStatusSaves = new Map()
  previewComment: Comment;
  sampleToSearch: string;
  showPlateView: boolean;
  showDialogue= false;
  showMultipleCommentDialog = false;
  enteredPuid: string;
  enteredPassword: string;
  enteredPasswordToByeArray: any[];
  puidPopup: boolean = false;
  puidPopupFunction: string;
  isVisible:boolean=false;

  isSampleQCFileNotSelected : boolean = true;
  uploadedFile : File;
  maUploadedFile : File;
  @ViewChild('sampleQCFileInput')
  fileUploadElement: ElementRef

  @ViewChild('qpcrFile')
  manualEXELElement: ElementRef;
  // NGS Variables Start Here
  selectedBatch: Covid19Batch;
  selectedBatchStepsMap: Map<string, Step> = new Map();
  mapOfProcessStepsFlow : Map<string, string[]> = new Map();
  selectedProcessStep: string;
  processStepChemicals: any;
  mapOfProcessStepsStatus = new Map();
  noChemicalEdit : boolean;
  batches: Covid19Batch[] = [];
  dirty = false;
  refStatusOfPrev: string;
  selectedLab: LabMDM;
  posControlsForLab: number;
  negativeControlForLab: number;
  posControlsRemaining: number;
  negativeControlRemaining: number;
  totalPCRControls: number;
  commentsMap = new Map<string, Comment[]>();
  enteredScanPlateBarcode: string;
  tags: any[] = [];
  tagsList : any[] = [];
  cachedTags: any[] = [];
  cachedTagsList : any[] = [];
  selectedTagPlate: string;
  commentPopup: boolean;
  batchToSearch: string;
  batchHistoryId: string;
  fieldBatchID:string = "BatchId";
  allowCreate: boolean = false;
  selectedSender: SenderDTO;
  mapOfSenders = new Map<string, any>();
  showBatch: boolean = false;
  batchHistory: any[] = [];
  groupedBatches: BatchGroup[] = [];
  deactivatePlateView = false;
  mapOfTagsFromMDM = new Map();
  mapOfTags = new Map();
  sourceBatchSamplesMap: Map<string, CovidSamples[]> = new Map();
  selectedTagPlateA1: string;
  selectedTagPlateA2: string;
  selectedTagPlateB1: string;
  selectedTagPlateB2: string;
  tagPlateBarcodeA1: string;
  tagPlateBarcodeA2: string;
  tagPlateBarcodeB1: string;
  tagPlateBarcodeB2: string;
  mergedSamples: Map<string,CovidSamples>=new Map();
  selectableLab: SelectableLab;
  checkForTagPlateDuplicate: boolean=false;
  checkForTagPlateDuplicateOnChange: boolean=false;
  sourceBatchCommentsMap:Map<string, Comment[]> = new Map();
  sourceCommentsFlagIndicator: boolean = false;
  sourceBatchCommt:Comment[] = [];
  selectedSearchFilter: any;
  valueToSearch: any;
  selectedStates: string[] = [];
  toDate: any;
  searchFilterList: { label: string; value: string; }[];
  dillusionFactorForSampleQC: number = 1;
  isFileNotSelected:boolean=false;
  tagObj: Tags;
  subSender = new Set();
  subSenderForPlateOne = new Set();
  subSenderForPlateTwo = new Set();
  subSenderForPlateThree = new Set();
  subSenderForPlateFour = new Set();
  mapOfQCBatchView = new Map();
  storage: string;
  plateViewDataFetched = false;
  showFilledTemplateLabel: boolean = false;
  mapOfPlannedTags = new Map();
  analysisPlateView: boolean = false;
  sameScanBatch: boolean = false;
  scanBlock: boolean = false;

  plateMap = new Map();
  sampleQcToBeDiluted: boolean = false;
  sampleQCDilutionSubHeader: string = "";
  sampleQcPartialReupload: boolean = false;
  sampleQcCompleteReupload: boolean = false;
  samplesWithHighConcentration: CovidSamples[] = []
  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  clone = rfdc();
  @ViewChild('plateView')
  plateViewCmp: PlateViewComponent;
  plateViewMode = "ARTIC_PLATE_VIEW_MODE";
  verifyReceptionPUID: boolean;
  sampleQCPerformedForSelectedBatch: boolean = false;

  skipProcessStepsPopUpHeader: string = "";
  skipProcessStepsPopUpButtonStatus: string = "";
  skipProcessStepsPopUp:boolean = false;
  machinesList: Machine[];
  machinesBarcodeMap: Map<string, Machine> = new Map();

  constructor(private masterDataService: MasterDataService, private apgTestingService: APGTestingService, private runPlanningService: RunPlanningService,
    private _messagesService: MessagesService, private confirmationService: ConfirmationService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.showPlateView = false;
    this.filterOptions = [
      { label: 'Receive Batch', value: PlateStatus.BATCH_RECEIVED },
      { label: 'Plate Transfer', value: PlateStatus.PLATE_TRANSFERRED },
      { label: 'Start Sample QC', value: PlateStatus.START_SAMPLE_QC },
      { label: 'Complete Sample QC', value: PlateStatus.COMPLETE_SAMPLE_QC },
      { label: 'Start Normalization', value: PlateStatus.START_NORMALIZATION },
      { label: 'Complete Normalization', value: PlateStatus.COMPLETE_NORMALIZATION },
      { label: 'Skip Normalization', value: PlateStatus.SKIP_NORMALIZATION },
      { label: 'Start Tagmentation', value: PlateStatus.START_TAGMENTATION },
      { label: 'Complete Tagmentation', value: PlateStatus.COMPLETE_TAGMENTATION },
      { label: 'Start Purification', value: PlateStatus.START_PURIFICATION },
      { label: 'Complete Purification', value: PlateStatus.COMPLETE_PURIFICATION },
      { label: 'Start Ligation', value: PlateStatus.START_LIGATION },
      { label: 'Complete Ligation', value: PlateStatus.COMPLETE_LIGATION },
      { label: 'Start Clean Up', value: PlateStatus.START_CLEAN_UP },
      { label: 'Complete Clean Up', value: PlateStatus.COMPLETE_CLEAN_UP },
      { label: 'Start Lib QC', value: PlateStatus.START_LIB_QC },
      { label: 'Complete Lib QC', value: PlateStatus.COMPLETE_LIB_QC }
    ];
    this.getAllActiveWorkFlowList();
    this.findControlesDetails();
    this.fetchAllActiveMachines();

    //hardcoding preview comment - to be removed
    this.previewComment = new Comment();

    this.activatedRoute.queryParams.subscribe(params=>{
      var batchID: string = params['batchID']
      if(batchID && batchID.trim()!==''){
        this.batchToSearch = batchID;
        this.searchForBatch()
      }
    })

    // NGS Variables Start Here
    this.selectedBatch = new Covid19Batch();

    this.mapOfStatusSaves.set(PlateStatus.BATCH_UPLOADED, "uploadBatch");
    this.mapOfStatusSaves.set(PlateStatus.BATCH_RECEIVED, "receiveBatch");
    this.mapOfStatusSaves.set(PlateStatus.PLATE_TRANSFERRED, "transferPlate")
    this.mapOfStatusSaves.set(PlateStatus.START_NORMALIZATION, "startNormalization");
    this.mapOfStatusSaves.set(PlateStatus.COMPLETE_NORMALIZATION, "completeNormalization");
    this.mapOfStatusSaves.set(PlateStatus.START_LIGATION, "startLigation");
    this.mapOfStatusSaves.set(PlateStatus.COMPLETE_LIGATION, "completeLigation");
    this.mapOfStatusSaves.set(PlateStatus.START_LIB_QC, "startLibQC");
    this.mapOfStatusSaves.set(PlateStatus.COMPLETE_LIB_QC, "completeLibQC");
    this.mapOfStatusSaves.set(PlateStatus.START_SAMPLE_QC, "startSampleQC");
    this.mapOfStatusSaves.set(PlateStatus.COMPLETE_SAMPLE_QC, "completeSampleQC");
    this.mapOfStatusSaves.set(PlateStatus.START_TAGMENTATION, "startTagmentation");
    this.mapOfStatusSaves.set(PlateStatus.COMPLETE_TAGMENTATION, "completeTagmentation");
    this.mapOfStatusSaves.set(PlateStatus.START_PURIFICATION, "startPurification");
    this.mapOfStatusSaves.set(PlateStatus.COMPLETE_PURIFICATION, "completePurification");
    this.mapOfStatusSaves.set(PlateStatus.START_CLEAN_UP, "startCleanUp");
    this.mapOfStatusSaves.set(PlateStatus.COMPLETE_CLEAN_UP, "completeCleanUp");
    this.mapOfStatusSaves.set("GO_TO_TAGMENTATION", "goToTagmentation");
    this.mapOfStatusSaves.set("SKIP_NORMALIZATION", "skipNormalization");

    this.mapOfProcessStepsFlow.set(ProcessStep.TRANSFER_PLATE, [ProcessStep.RECEIVE_BATCH]);
    this.mapOfProcessStepsFlow.set(ProcessStep.SAMPLE_QC, [ProcessStep.TRANSFER_PLATE]);
    this.mapOfProcessStepsFlow.set(ProcessStep.NORMALIZATION, [ProcessStep.SAMPLE_QC]);
    this.mapOfProcessStepsFlow.set(ProcessStep.TAGMENTATION, [ProcessStep.NORMALIZATION]);
    this.mapOfProcessStepsFlow.set(ProcessStep.PURIFICATION, [ProcessStep.TAGMENTATION]);
    this.mapOfProcessStepsFlow.set(ProcessStep.INDEX_LIGATION, [ProcessStep.PURIFICATION]);
    this.mapOfProcessStepsFlow.set(ProcessStep.CLEAN_UP, [ProcessStep.INDEX_LIGATION]);
    this.mapOfProcessStepsFlow.set(ProcessStep.LIBRARY_QC, [ProcessStep.CLEAN_UP]);

    this.mapOfProcessStepsStatus.set(PlateStatus.BATCH_UPLOADED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.BATCH_RECEIVED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.PLATE_TRANSFERRED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.START_NORMALIZATION, [ProcessStep.NORMALIZATION]);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETE_NORMALIZATION, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.START_LIGATION, [ProcessStep.INDEX_LIGATION]);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETE_LIGATION, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.START_LIB_QC, [ProcessStep.LIBRARY_QC]);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETE_LIB_QC, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.START_SAMPLE_QC, [ProcessStep.SAMPLE_QC]);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETE_SAMPLE_QC, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.START_TAGMENTATION, [ProcessStep.TAGMENTATION]);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETE_TAGMENTATION, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.START_PURIFICATION, [ProcessStep.PURIFICATION]);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETE_PURIFICATION, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.START_CLEAN_UP, [ProcessStep.CLEAN_UP]);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETE_CLEAN_UP, []);


    this.apgTestingService.getBatchesForLab(this.selectedLabId).subscribe({
      next : (results) => {
        this.batches = results.data;
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    })

    this.searchFilterList = [
      {label:'Batch Id',value:'BatchId'},
      {label:'Sample Id',value:'SampleId'},
      {label:'External Id',value:'ExternalId'},
      {label:'Library Id',value:'LibraryId'}
    ];
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  findControlesDetails() {
    this.masterDataService.findLabById(this.selectedLabId).subscribe({
      next : (result) => {
        if (result.data == null || result.data == undefined || result.data.length == 0) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Lab not found!', detail: 'Contact Administrator to resolve this issue.' });
          return;
        }
        this.selectedLab = result.data;
        this.posControlsRemaining = this.selectedLab.numberOfPC;
        this.negativeControlRemaining = this.selectedLab.numberOfNC;
        this.posControlsForLab = this.selectedLab.numberOfPC;
        this.negativeControlForLab = this.selectedLab.numberOfNC;
        this.totalPCRControls = this.selectedLab.numberOfPositivePCRControls + this.selectedLab.numberOfNegativePCRControls;
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    });
  }

  batchViewVisbility(event: any) {
    this.batchToSearch = event.data.batchID;
    this.sampleToSearch = '';
    this.searchForBatch();
    this.batchHistoryId=this.batchToSearch;
    this.fileUploadElement.nativeElement.value = "";
    this.isSampleQCFileNotSelected = true;
  }

  searchBatch() {
    this.batchToSearch = this.batchHistoryId;
    this.searchForBatch();
  }

  searchForBatch() {
    if (this.batchToSearch == null || this.batchToSearch == undefined || this.batchToSearch.trim() === '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to search' });
      return;
    }
    this.searchForBatchAction(this.selectedLabId, this.batchToSearch.trim());
  }

  searchForBatchAction(labID: string, batchID: string) {
    this.blocked = true;
    this.batchHistoryId = '';
    this.subSender.clear();
    this.subSenderForPlateOne.clear();
    this.subSenderForPlateTwo.clear();
    this.subSenderForPlateThree.clear();
    this.subSenderForPlateFour.clear();
    this.mapOfQCBatchView.clear();
    this.getDataForLabPlanningAndSearch(labID,batchID);
    // this.apgTestingService.getStorageForBatch(labID, batchID).subscribe(
    //   result => {
    //     if (result && result.data) {
    //       if (result.data == "Plate Not Stored") {
    //         this.storage = result.data;
    //       }
    //       else {
    //         this.storage = result.data[batchID];
    //       }
    //       this.blocked=false;
    //     }
    // });
  }

  getDataForLabPlanningAndSearch(labID: string, batchID: string) {
    this.blocked = true;
    let batches$ =  this.apgTestingService.getBatchForLabAndBatchId(labID,this.fieldBatchID ,batchID)
    batches$.subscribe({
      next:(results) => {
      if(results.data){
          this.selectedBatch = results.data;
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this.setBatchView();
          this.allowCreate = false;
          this.plateViewDataFetched = false;
          this.setTemplateButtonLabel();
          this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
          this.populateBatchHistory();
          this.getActiveTagPlatesFromMDM();
          this.getMapofPlannedTagPlates();
          this.prepareProcessStepsMap();
          if(this.selectedBatch.statusOfTheBatch == PlateStatus.START_SAMPLE_QC){
            this.validateSampleQC(this.selectedBatch.samples)
          }
      } else {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with BatchID ' + this.batchToSearch });
      }      this.populateBatchHistory()
      this.setBatchView();
      this.blocked = false;
      },
      error: (error: any) => {
      this.blocked = false;
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
      this.plateViewDataFetched = false;
      this.setBatchView();
      }

    })
  }

  prepareProcessStepsMap() {
    this.selectedBatchStepsMap.clear();
    if(!this.selectedBatch.processSteps || this.selectedBatch.processSteps==null)
      return;
    this.selectedBatch.processSteps.forEach(step => {
      this.selectedBatchStepsMap.set(step.step, step);
      }
    )
  }

  setBatchView() {
    this.showPlateView = false;
  }

  setTemplateButtonLabel() {
    if (['CREATE_BATCH', 'SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'].includes(this.selectedBatch.statusOfTheBatch))
      this.showFilledTemplateLabel = false;
    else
      this.showFilledTemplateLabel = true;
  }

  assignButtonDisabled(){
    return !(this.enteredScanPlateBarcode && this.enteredScanPlateBarcode.trim()!='');
  }

  openVerifyReceptionPopup() {
    this.enteredScanPlateBarcode = "";
    this.findAndHighlightElement("focus1")
    this.verifyReceptionPUID = true;
  }

  verifyReception (vrTagPlateName: string) {
    this.verifyReceptionPUID = false;
    this.assignTagPlateName(vrTagPlateName);
    }

  assignTagPlateName(vrTagPlateName:string) {

    if(this.mapOfTagsFromMDM.has(this.selectedTagPlate) || this.selectedBatch.plannedTagPlate){
      if (this.selectedBatch.plannedTagPlate) {
        this.assignTagPlateNameForPlannedTagPlates(vrTagPlateName);
      } else {
        this.tagObj = this.mapOfTagsFromMDM.get(this.selectedTagPlate);
        let tag = this.tagObj.tagPlateBarcode;
        if(!tag.includes(vrTagPlateName)){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Invalid Plate Barcode!!',
            detail: 'Tag Plate Barcode not configured in MDM for the selected Tag Plate.',
          });
          return;
        }
      }

    } else{
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid Plate Selected!!',
        detail: 'Selected Tag Plate has been inactivated in MDM. Please change or re-activate the Tap Plate',
      });
      return;
    }

    if (!this.selectedBatch.plannedTagPlate) {
      this.getTagPlateForPlannedBatches(vrTagPlateName);
    }
  }

   assignTagPlateNameForPlannedTagPlates(vrTagPlateName: string) {

        this.tagObj = this.mapOfPlannedTags.get(this.selectedTagPlate);
        let tag = this.tagObj.tagPlateBarcode;
        if(!tag.includes(vrTagPlateName)){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Invalid Plate Barcode!!',
            detail: 'Tag Plate Barcode not configured in MDM for the selected Tag Plate.',
          });
          return;
        }
        this.getTagPlateForPlannedBatches(vrTagPlateName);

  }

  getTagPlateForPlannedBatches(vrTagPlateName:string) {
    this.selectedBatch.assignTagPlateDateTime = new Date();
    this.selectedBatch.tagPlateBarcode = vrTagPlateName;
    this.selectedBatch.tagPlateId = this.selectedTagPlate;
    if(this.selectedBatch.tagPlateId && this.selectedBatch.tagPlateId.trim() != ''){
      let tagPlate = this.mapOfTags.get(this.selectedBatch.tagPlateId)
      if (tagPlate) {
        for(let sample of this.selectedBatch.samples) {
          let position = this.getSamplePositionString(sample);
          let tag = tagPlate[position];
          if(tag != null && tag != undefined){
            sample.tagPlateId = tag.tagPlate;
            sample.u7Sequence = tag.u7Sequence;
            sample.u5Sequence = tag.u5Sequence
          } else {

            this.errorBlock();
            return;
          }
        }
      } else {

        this.errorBlock();
        return;
      }

    }
    this.updateBatch(PlateStatus.START_LIGATION);
  }

  getSamplePositionString(sample: CovidSamples){
    let position = String.fromCharCode(64 + sample.positionRow);
    if(sample.prositionCol < 10)
      position += '0';
    position += sample.prositionCol;
    return position;
  }

  convertStringToUTF8ByteArray(str) {
    let data = [];
    for (let i = 0; i < str.length; i++) {
      data.push(str.charCodeAt(i));
    }
    return data;
  }

  errorBlock() {
    this._messagesService.addErrorMessage({
      severity: 'error', summary: 'Tag not present!',
      detail: 'Failed to fetch the tag, Please connect with blueberry support',
    });
    this.selectedBatch.assignTagPlateDateTime=null;
    this.selectedBatch.tagPlateBarcode=null;
    this.selectedBatch.tagPlateId=null;

  }

  populateBatchHistory() {
    let sourceBatchIds = this.selectedBatch.wellType == 'WELL384' ? this.selectedBatch.sourceBatchIds.join(",") : '';
    this.apgTestingService.getBatchHistory(this.selectedBatch.lab, this.selectedBatch.batchID, this.selectedBatch.wellType, sourceBatchIds).subscribe(
      result => {
        this.batchHistory = [];
        this.groupedBatches = [];
        if (result.data) {
          if (this.selectedBatch.wellType == 'WELL384') {
            let groupLabel = '';
            Object.entries(result.data).forEach(([key]) => {
              let batchGroup = new BatchGroup();
              let batcheIds = result.data[key];
              batcheIds.forEach((element: string) => {
                if (this.selectedBatch.sourceBatchIds.includes(element)) {
                  groupLabel = element;
                }
              });
              batchGroup.label = groupLabel;
              result.data[key].forEach((element: string) => {
                let batchItems = new BatchItemHistory();
                batchItems.label = element;
                batchItems.value = element;
                batchGroup.items.push(batchItems);
              });
              this.groupedBatches.push(batchGroup);
            });
          } else {
            result.data.forEach(batch => {
              this.batchHistory.push({label: batch, value: batch});
            });
          }
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  getActiveTagPlatesFromMDM(){
    this.masterDataService.getMapOfTagsFromMDM(this.selectedLabId, this.selectedBatch.tagSystemName).subscribe({
      next : (result) => {
        if (result.data) {
          this.mapOfTagsFromMDM = new Map(Object.entries(result.data))
        }
        this.populateTags();
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    });
  }

  getMapofPlannedTagPlates(){
    this.masterDataService.getMapOfTagsFromMDMForPlannedTagPlates(this.selectedLabId,this.selectedBatch.tagSystemName,true).subscribe({
      next : (result) => {
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfPlannedTags.set(key, value);
          });
        }
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    });
  }

  populateTags(){
    this.masterDataService.getMapOfTags(this.selectedLabId, this.selectedBatch.tagSystemName).subscribe({
      next : (result) => {
        if (result.data) {
          this.cachedTags = [];
          this.cachedTagsList = [];
          this.mapOfTags.clear();
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfTags.set(key, value);
            if (this.mapOfTagsFromMDM.has(key)) {
              this.cachedTags.push({ label: key, value: key });
              this.cachedTagsList.push(key);
            }
            this.tags = [...this.cachedTags];
            this.tagsList = [...this.cachedTagsList];
            this.tagObj = this.mapOfTagsFromMDM.get(this.selectedBatch.tagPlateId);
            if (!this.selectedBatch.plannedTagPlate) {
              if (this.selectedBatch.tagPlateId && !this.mapOfTagsFromMDM.has(this.selectedBatch.tagPlateId)) {
                this.tags.push({ label: this.selectedBatch.tagPlateId, value: this.selectedBatch.tagPlateId });
                this.tagsList.push(this.selectedBatch.tagPlateId);
              } else {
                this.selectedTagPlate = this.selectedBatch.tagPlateId;
              }
            } else {

              this.selectedTagPlate = this.selectedBatch.plannedTagPlate;
              this.tags.push({ label: this.selectedBatch.plannedTagPlate, value: this.selectedBatch.plannedTagPlate });
              this.tagsList.push(this.selectedBatch.tagPlateId);
            }
          });
        }
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    });
  }

  saveBatchStatus(status: string) {
    if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to save' });
      return;
    }
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.dirty) {
      this.confirmationService.confirm({
        message: this.scanDialogMessage,
        header: 'Discard Changes?',
        accept: () => {
          this.dirty = false;
          this.saveBatchStatusAction(status);
        },
        reject: () => { }
      });
    } else {
      this.saveBatchStatusAction(status);
    }
  }

  saveBatchStatusAction(status: string) {
    let functionName = this.mapOfStatusSaves.get(status);
    this[functionName](status);
  }

  showChemicalPopup(processStep?: string) {
    
    this.selectedProcessStep = processStep;
    this.masterDataService.getAllActiveChemicals(this.selectedLabId, "chemical").subscribe({
      next : (result) => {
      this.processStepChemicals = result.data.filter(chemical => (chemical.processStep === processStep));
    },error:(error: any) => {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
    }});

    if(this.selectedBatch.statusOfTheBatch && !this.mapOfProcessStepsStatus.get(this.selectedBatch.statusOfTheBatch) && !this.mapOfProcessStepsStatus.get(this.selectedBatch.statusOfTheBatch).includes(processStep) || this.selectedBatch.statusOfTheBatch == null){
      this.noChemicalEdit = true;
    } else {
      this.noChemicalEdit = false;
    }

    this.showDialogue= true;
  }

  hideChemicalDialog(batch: Covid19Batch){
    this.showDialogue = false;
    if (batch.batchID !== undefined)
      this.searchForBatchAction(this.selectedLabId, batch.batchID);
  }

  uploadBatch(status: string){
    if(!this.updateProcessStep(ProcessStep.UPLOAD_BATCH, ProcessStepStage.start, true)){
      return;
    }
    this.updateBatch(status);
  }

  receiveBatch(status: string){
    if(!this.updateProcessStep(ProcessStep.RECEIVE_BATCH, ProcessStepStage.start, true)){
      return;
    }
    this.selectedBatch.filterDateTime = new Date();
    this.selectedBatch.deliveryTargetDateTime = this.addBusinessDays(this.selectedBatch.batchReceivedDateTime, 7);
    this.updateBatch(status);
  }

  transferPlate(status: string){
    if(!this.selectedBatch.aliquotPlateID || this.selectedBatch.aliquotPlateID===''){
      this._messagesService.addErrorMessage({
        severity: 'error', detail: 'Aliquot plate ID must not be empty'
      })
      return;
    }
    if(this.selectedBatch.batchID+'_A'!==this.selectedBatch.aliquotPlateID){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Wrong aliquot plate ID',
        detail: 'Wrong aliquot plate: '+this.selectedBatch.aliquotPlateID+ ' for plate: '+this.selectedBatch.batchID
      })
      return;
    }
    if(!this.updateProcessStep(ProcessStep.TRANSFER_PLATE, ProcessStepStage.start, true)){
      return;
    }
    this.updateBatch(status);
  }

  updateBatch(statusOfBatch: string) {
    this.refStatusOfPrev = this.selectedBatch.previousStatusOfTheBatch;
    this.selectedBatch.statusOfTheBatch = statusOfBatch;
    this.selectedBatch.previousStatusOfTheBatch = statusOfBatch;
    this.saveBatchData();
    this.skipProcessStepsPopUp = false;
  }

  startNormalization(status: string){
    if(!this.updateProcessStep(ProcessStep.NORMALIZATION, ProcessStepStage.start)){
      return;
    }
    this.updateBatch(status);
  }

  completeNormalization(status: string){
    if(!this.updateProcessStep(ProcessStep.NORMALIZATION, ProcessStepStage.end)){
      return;
    }
    this.updateBatch(status);
  }

  startLigation(status: string){
    if(!this.updateProcessStep(ProcessStep.INDEX_LIGATION, ProcessStepStage.start)){
      return;
    }
    this.updateBatch(status);
  }

  completeLigation(status: string){
    if(!this.updateProcessStep(ProcessStep.INDEX_LIGATION, ProcessStepStage.end)){
      return;
    }
    this.updateBatch(status);
  }

  startLibQC(status: string){
    if(!this.updateProcessStep(ProcessStep.LIBRARY_QC, ProcessStepStage.start)){
      return;
    }
    this.createDilutedSamples(status);
  }

  completeLibQC(status: string){
    if(!this.updateProcessStep(ProcessStep.LIBRARY_QC, ProcessStepStage.end)){
      return;
    }
    this.updateBatch(status);
    this.publishLibrariesForSelectedBatch();
    this.commentPopup = false;
  }

  startSampleQC(status: string){
    if(!this.updateProcessStep(ProcessStep.SAMPLE_QC, ProcessStepStage.start)){
      return;
    }
    this.updateBatch(status);
  }

  completeSampleQC(status: string){
    if(!this.selectedBatch || !this.selectedBatch.samples || this.selectedBatch.samples.length<1){
      this._messagesService.addWarningMessage({
        severity: 'warn', detail: 'No samples found to complete sample QC'
      })
      return;
    }
    if(!this.selectedBatch.sampleQCResultUploaded){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Result not uploaded',
        detail: 'Please upload sample QC result to complete the process'
      })
      return;
    }
    if(!this.validateSampleQC(this.selectedBatch.samples)){
      return;
    }
    if(!this.updateProcessStep(ProcessStep.SAMPLE_QC, ProcessStepStage.end)){
      return;
    }
    this.updateBatch(status);
    this.commentPopup = false;
  }

  startTagmentation(status: string){
    if(!this.updateProcessStep(ProcessStep.TAGMENTATION, ProcessStepStage.start)){
      return;
    }
    this.updateBatch(status);
  }

  completeTagmentation(status: string){
    if(!this.updateProcessStep(ProcessStep.TAGMENTATION, ProcessStepStage.end)){
      return;
    }
    this.updateBatch(status);
  }

  startPurification(status: string){
    if(!this.updateProcessStep(ProcessStep.PURIFICATION, ProcessStepStage.start)){
      return;
    }
    this.updateBatch(status);
  }

  completePurification(status: string){
    if(!this.updateProcessStep(ProcessStep.PURIFICATION, ProcessStepStage.end)){
      return;
    }
    this.updateBatch(status);
  }

  startCleanUp(status: string){
    if(!this.updateProcessStep(ProcessStep.CLEAN_UP, ProcessStepStage.start)){
      return;
    }
    this.updateBatch(status);
  }

  completeCleanUp(status: string){
    if(!this.updateProcessStep(ProcessStep.CLEAN_UP, ProcessStepStage.end)){
      return;
    }
    this.updateBatch(status);
  }
  
  goToTagmentation(_status: string){
    if(!this.updateSkipProcessStep([ProcessStep.SAMPLE_QC,ProcessStep.NORMALIZATION])){
      return;
    }
    this.updateBatch(PlateStatus.SKIP_NORMALIZATION);
  }

  skipNormalization(_status: string){
    if(!this.updateSkipProcessStep([ProcessStep.NORMALIZATION])){
      return;
    }
    this.updateBatch(PlateStatus.SKIP_NORMALIZATION);
  }

  updateSkipProcessStep(steps: string[]): boolean{
    steps.forEach((step, stepIndex) => {
      this.selectedBatch.processSteps = (!this.selectedBatch.processSteps || this.selectedBatch.processSteps==null) ? [] : this.selectedBatch.processSteps;
      var newStep = new Step();
      newStep.step = step;
      newStep.startTimeStamp = null;
      newStep.startPUID = this.puid;
      newStep.endPUID = this.puid;
      if((stepIndex+1) == steps.length){
        newStep.endTimeStamp = new Date();
      }
      else{
        newStep.endTimeStamp = null;
      }
      this.selectedBatch.processSteps.push(newStep);  
    })
    return true;
  }

  updateProcessStep(step: string, stage: ProcessStepStage, singleStage?: boolean): boolean {
    if(this.selectedBatchStepsMap.has(step)){
      var existingStep = this.selectedBatch.processSteps.find(s => s.step == step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        if(singleStage){
          existingStep.endTimeStamp = new Date();
          existingStep.endPUID = this.puid;
        }
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }
    }else{
      this.selectedBatch.processSteps = (!this.selectedBatch.processSteps || this.selectedBatch.processSteps==null) ? [] : this.selectedBatch.processSteps;
      var newStep = new Step();
      newStep.step = step;
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        if(singleStage){
          newStep.endTimeStamp = new Date();
          newStep.endPUID = this.puid;
        }
      }else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      this.selectedBatch.processSteps.push(newStep);
    }
    return true;
  }

  disableButton(stage: number, stepName: string): boolean{
    if((!this.selectedBatchStepsMap || this.selectedBatchStepsMap==null || this.selectedBatchStepsMap.size < 1)){
      return true;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName,this.selectedBatchStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName,this.selectedBatchStepsMap);
      default:
        return true;
    }
  }
  
  disableLibQCResultButton() {
    let disable = false;
    let libQCResultProcessStep = this.selectedBatchStepsMap.get("LIBRARY_QC");
    if(!libQCResultProcessStep)
        return true;
    let samples = this.selectedBatch.samples;
    for(let i=0; i<samples.length; i++){
        if(!samples[i].libConcentration){
            disable = true;
            break;
        }
    }
    return disable;
}

  disableProcessStepStart(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    let dependentSteps: string[] = this.mapOfProcessStepsFlow.get(stepName);
    let disable: boolean = true;
    if(!dependentSteps){
      return false;
    }
    for(let step of dependentSteps){
      let dependentProcessStep = selectedPlateStepsMap.get(step);
      if(dependentProcessStep && !this.isEmptyString(dependentProcessStep.endPUID) && !this.isEmptyDate(dependentProcessStep.endTimeStamp)){
        disable = false;
      }else{
        disable = true;
        break;
      }
    }
    if(selectedPlateStepsMap.has(stepName)){
      disable = true;
    }
    return disable;
  }

  disableProcessStepEnd(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(!this.isEmptyString(currentProcessStep.endPUID) && this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true
      return disable
    }
    if(this.isEmptyString(currentProcessStep.endPUID) || this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = false;
    }
    return disable;
  }

  saveBatchData(){
    if(!this.selectedBatch){
      this._messagesService.addSuccessMessage({
        severity: 'error', summary: 'Batch not selected!',
        detail: 'Please select a batch to continue'
      });
      return
    }
    this.selectedBatch.lab = this.selectedLabId;
    this.selectedBatch.userID = this.puid;
    this.qcSuccessResponse()
    this.blocked = true;
    this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe({
      next : (result) => {
        this.blocked = false;
        if (result.data) {
          this.selectedBatch = result.data;
          this.prepareProcessStepsMap();
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this.enteredPassword = "";
          this.enteredPuid = "";
          this.enteredScanPlateBarcode = "";
          if (this.selectedBatch.statusOfTheBatch === "START_TAG_PCR" && !this.selectedBatch.tagPlateBarcode) {

            let indexOfLastTagPlateId = this.tagsList.indexOf(this.selectedBatch.tagPlateId);
            if (indexOfLastTagPlateId == -1) {

              let cacheListForTest = [...this.tagsList];
              cacheListForTest.push(this.selectedBatch.tagPlateId);
              cacheListForTest.sort((a, b) => a - b);

              let indexOfLastTagPlateIdCheck = cacheListForTest.indexOf(this.selectedBatch.tagPlateId);
              this.setTagPlateId(cacheListForTest, indexOfLastTagPlateIdCheck);
            } else {
              this.setTagPlateId(this.tagsList, indexOfLastTagPlateId);
            }
            if(this.selectedBatch.plannedTagPlate){
              this.selectedTagPlate = this.selectedBatch.plannedTagPlate;
            } else {
              this.selectedTagPlate = this.selectedBatch.tagPlateId;
            }
          }

          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Updated!',
            detail: 'Batch ' + this.selectedBatch.batchID + ' has been updated successfully'
          });
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.selectedBatch.statusOfTheBatch = this.refStatusOfPrev;
        this.selectedBatch.previousStatusOfTheBatch = this.refStatusOfPrev;
        this.enteredPassword = "";
        this.enteredPuid = "";
        this.enteredScanPlateBarcode = "";
        if (this.selectedBatch.statusOfTheBatch==="START_TAG_PCR") {
          this.selectedBatch.tagPlateBarcode = "";
          this.selectedBatch.assignTagPlateDateTime=null;
          this.selectedBatch.assignTagPlatePUID="";
        }
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    });
  }

  disableLibQCMachine(){
    return !this.selectedBatch.batchID
  }

  qcSuccessResponse() {
    if(this.selectedBatch.previousStatusOfTheBatch == 'COMPLETE_ARTIC_QC')
      this.selectedBatch.articQCFailed=false
    else if(this.selectedBatch.previousStatusOfTheBatch == PlateStatus.COMPLETE_LIB_QC)
      this.selectedBatch.libQCFailed=false
    else if(this.selectedBatch.previousStatusOfTheBatch == 'READY_FOR_DELIVERY')
      this.selectedBatch.finalQCFailed=false
    else if(this.selectedBatch.previousStatusOfTheBatch == 'COMPLETE_FINAL_QC')
      this.selectedBatch.dataReviewFailed=false
  }

  setTagPlateId(tagPlateArr: any[], index: number){
    if (index + 1 == tagPlateArr.length) {
      this.selectedBatch.tagPlateId = tagPlateArr[0];
    } else {
      this.selectedBatch.tagPlateId = tagPlateArr[index + 1];
    }
  }

  addBusinessDays(d:Date, n:number) {
    d = new Date(d.getTime());
    let day = d.getDay();
    d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
    return d;
  }

  getViewPlateIcon(plateViewStatus: boolean) {
    return this.showPlateView ? 'fa fa-list-alt' : 'fa fa-th';
  }

  searchButtonDisabledIf(){
    return !(this.selectedSearchFilter && this.valueToSearch && this.valueToSearch.trim() != '' );
  }

  searchForBatchWIthFilter(){
    if(!this.valueToSearch || this.valueToSearch.trim() ==''){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Entered', detail: 'Please Enter the value to search.' });
      return;
    }
    this.getDataForLabPlanning();
  }

  getDataForLabPlanning() {
    this.blocked = true;
    let batches$ = this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId , this.selectedSearchFilter, this.valueToSearch.trim() );
    batches$.subscribe({next : (results) => {
      if(results.data){
        this.selectedBatch = results.data;
        this.showMessageForSearchBatch();
        this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
        this.valueToSearch = '';
        this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
        this.getActiveTagPlatesFromMDM();
        this.getMapofPlannedTagPlates();
      } else {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with '+this.selectedSearchFilter +' '+ this.valueToSearch });
      }      this.populateBatchHistory()
      this.setBatchView();
      this.blocked = false;
    }, error: (error: any) => {
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
      this.setBatchView();
      }

    })
  }

  showMessageForSearchBatch(){
    if(this.selectedBatch.workflowGroup != null && this.selectedBatch.workflowGroup === 'Midplex'){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Midplex Batch found!', detail: 'Batch '+this.selectedBatch.batchID+' is a Midplex batch that can not be processed on this page'});
          }
   else if(this.selectedBatch.matchedBatchCount == 1){
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Batch Found!',
        detail: 'Batch for ' + this.valueToSearch + ' is Found.'});
    }else if([2,3,4,5].includes(this.selectedBatch.matchedBatchCount)){
      this._messagesService.addWarningMessage({
      severity: 'warn',
      summary: 'Multiple Batchs Found',
      detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.selectedBatch.matchedBatchCount+' Batch Id\'s are : '
      +this.selectedBatch.matchedBatchIDs});
    }else if(this.selectedBatch.matchedBatchCount>1) {
      this._messagesService.addWarningMessage({
        severity: 'warn',
        summary: 'Multiple Batchs Found',
        detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.selectedBatch.matchedBatchCount});
    }
  }

  getfunction(){
    if(this.selectedBatch.sender){
      if(this.selectedBatch.sender.length <= 21){
        return this.selectedBatch.sender
      }else if(this.selectedBatch.sender.length > 21){
        return this.selectedSender.senderShortName
      }
    }
  }

  getSamplesCount(){
    if(this.selectedBatch.wellType==WellType.WELL384){
        return this.selectedBatch.sampleListSizeWithoutControls;
    }else{
      if(this.selectedBatch.samples){
        return this.selectedBatch.samples.length;
      }
    }
  }

  togglePlateView() {
    if(this.showPlateView)
      this.selectedBatch = this.plateViewCmp.onChange();
    this.showPlateView = !this.showPlateView;
    // if (this.selectedBatch && (this.selectedBatch.wellType == WellType.WELL96) && this.showPlateView) {
    //   this.sameScanBatch = false;
    //   this.scanBlock = true;
    // }
  }

  getPreviewComment(batch: Covid19Batch) {
    let comment = new Comment();
    if (batch.comment && (!batch.comments || batch.comments.length == 0)) {
      comment.batchId = batch.batchID;
      comment.puid = '';
      comment.commentDate = null;
      comment.userComment = batch.comment;
      batch.comments.push(comment);
    }

    if (batch.comments && batch.comments.length > 0) {
      comment = batch.comments[batch.comments.length - 1];
    } else {
      comment.userComment = 'No Comments added yet'
    }
    return comment;
  }

  enableIfStatusIn(status: string[]){
    return !status.includes(this.selectedBatch.statusOfTheBatch)
  }

  disableReceiveBatch() {
    return !(this.selectedBatch.excelUploadCreatedAt && this.selectedBatch.excelUploadCreatedBy);
  }

  disableStartNormalization(){
    return !(this.selectedBatch.completeSampleQCDateTime && this.selectedBatch.completeSampleQCPUID)
  }

  disableCompleteNormalization(){
    return !(this.selectedBatch.startNormalizationDateTime && this.selectedBatch.startNormalizationPUID)
  }

  disableStartLigation(){
    return !(this.selectedBatch.completeArticPurificationDateTime && this.selectedBatch.completeArticPurificationPUID)
  }

  disableCompleteLigation(){
    return !(this.selectedBatch.startAdapterLigationDateTime && this.selectedBatch.startAdapterLigationPUID && this.selectedBatch.tagPlateBarcode)
  }

  disableStartLibQC(){
    return !(this.selectedBatch.startAdapterLigationDateTime && this.selectedBatch.startAdapterLigationPUID)
  }

  disableCompleteLibQC(){
    return !(this.selectedBatch.startLibQCDateTime && this.selectedBatch.startLibQCPUID)
  }

  disableStartSampleQC(){
    return !(this.selectedBatch.batchReceivedDateTime && this.selectedBatch.batchReceivedPUID)
  }

  disableCompleteSampleQC(){
    return !(this.selectedBatch.startSampleQCDateTime && this.selectedBatch.startSampleQCPUID)
  }

  disableStartTagmentation(){
    return !(this.selectedBatch.startNormalizationDateTime && this.selectedBatch.startNormalizationPUID)
  }

  disableCompleteTagmentation(){
    return !(this.selectedBatch.startArticTagmentationDateTime && this.selectedBatch.startArticTagmentationPUID)
  }

  disableStartPurification(){
    return !(this.selectedBatch.completeArticTagmentationDateTime && this.selectedBatch.completeArticTagmentationPUID)
  }

  disableCompletePurification(){
    return !(this.selectedBatch.startArticPurificationDateTime && this.selectedBatch.startArticPurificationPUID)
  }

  disableStartCleanUp(){
    return !(this.selectedBatch.completeAdapterLigationDateTime && this.selectedBatch.completeAdapterLigationPUID)
  }

  disableCompleteCleanUp(){
    return !(this.selectedBatch.startCleanUpDateTime && this.selectedBatch.startCleanUpPUID)
  }

  disableIfNoControls(){
    return false;
  }

  downloadFLXWorkFile(){
    this.blocked=true;
    this.apgTestingService.downloadFLXWorkFile(this.selectedBatch.batchID, this.selectedLabId).subscribe(
      results => {
        this.blocked=false;
        let blob = new Blob([results.fileContent], { type: 'text/plain' });
        this.saveFile(blob, "FLX_" + this.selectedBatch.batchID + ".txt");
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'FLX Work file has been downloaded',
        });
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Download Failed',
          detail: 'Could not download FLX Work file.',
        });
      });
  }

  downloadqPCRWorkfile(){
    this.apgTestingService.getqPCRWorkfile(this.selectedBatch.batchID, this.selectedLabId).subscribe({
      next : (result) => {
        let txtData = result.data;
        let blobTxt: Blob = new Blob([txtData], { type: "text/plain" });
        let fileTxt: string = this.selectedBatch.batchID + ".txt";
        saveByFileSaver(blobTxt, fileTxt);
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    });
  }

  downloadqPCRBioRadWorkfile(){
    this.apgTestingService.getqPCRBioRadWorkfile(this.selectedBatch.batchID, this.selectedLabId).subscribe(
      (result) => {
        this._messagesService.addSuccessMessage({
          severity:"success", summary:"File Download", detail:"qPCR Workfile Downloading..."
        })
        var blob = new Blob([result.fileContent], { type: 'text/csv' });
        saveByFileSaver(blob, result.filename);
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  downloadLibQCResults(){
    this.apgTestingService.getLibQCResults(this.selectedBatch.batchID, this.selectedLabId).subscribe(
      (result) => {
        this._messagesService.addSuccessMessage({
          severity:"success", summary:"File Download", detail:"LibQC Results Downloading..."
        })
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, this.selectedBatch.batchID + "_LibQC_Results.xlsx");
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  onFLXFileSelect(event){
    if(event.files[0].name.split('.').pop() != "txt"){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only Text files are allowed.',
      });
    }
  }

  saveFile(data: any, filename?: string) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    saveByFileSaver(blob, filename);
  }

  eligiblePlate(stage: number, stepName: string, actionName: string, actionPos: number){
    return false;
   }

  isEmptyString(val: string){
    return (!val || val==null || val==='')
  }

  isEmptyDate(val: Date){
    return (!val || val==null)
  }

  getAllActiveWorkFlowList() {
    this.blocked = true;
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe(results => {
      if (results && results.data) {
        this.workFlowData = results.data;
        this.workFlowData.forEach(e => {
          this.workFlowList.push({ label: e.workFlowName, value: e.workFlowName });
        });
        this.blocked = false;
      }
    },
      (error: any) => {
        this.blocked = false;
        this.showError(error);
      });

  }

  onApplyFilter() {
    this.loading = true;
    if (this.selectedStates.length == 0 && !this.fromDate && !this.toDate) {
      this.apgTestingService.getBatchesForLab(this.selectedLabId).subscribe({
        next : (results) => {
          this.batches = results.data;
          this.loading = false;
        },
        error: (error: any) => {
          this.errorHandler.handleError(error)
        }
      })
    }
    else {
      let toFilterDate: Date;
      if (!this.fromDate && !this.toDate && this.selectedStates.some( ai => APGCovid19Constants.terminatingStates.includes(ai))) {
        this.toDate = new Date();
        this.fromDate = new Date();
        this.fromDate.setDate(this.toDate.getDate() - 14);
      }
      let selectedStatusList = this.getStatusList();
      if(this.toDate){
        toFilterDate = new Date(this.toDate.getTime());
        toFilterDate.setDate(toFilterDate.getDate() + 1)
      }
      this.apgTestingService.filterBatchesForSamplesMenu(selectedStatusList, this.selectedLabId, !this.fromDate ? '' : this.fromDate.toDateString(), !this.toDate ? '' : toFilterDate.toDateString(), 'OrderReception').subscribe({
        next : (results) => {
          this.loading = false;
          this.batches = results.data;
        },
        error : (filterError) => {
          this.loading = false;
          let filtermessage = this.errorHandler.handleError(filterError);
          this._messagesService.addErrorMessage(filtermessage);
        }
     })
    }
  }

  private getStatusList() {
    if (this.selectedStates && this.selectedStates.length != 0)
      return this.selectedStates.join(",");
    else {
      let nonTerminatingStates = [];
      this.filterOptions.forEach(option => {
        if (!APGCovid19Constants.terminatingStates.includes(option.value))
          nonTerminatingStates.push(option.value);
      });
      return nonTerminatingStates.join(",");
    }
  }

  removeBatchSelection(){
    this.fileUploadElement.nativeElement.value = "";
    this.isSampleQCFileNotSelected = true;
    this.selectedBatch = new Covid19Batch();
    this.selectedBatchStepsMap = new Map();
  }

  getPlateViewButtonLabel(plateView: boolean) {
    if (plateView) {
      return 'Plate';
    }else {
      return 'View Plate';
    }
  }

  /**
   * Get samples at given row col value for the plate view
   * @param row
   * @param col
   */
  getSampleAt(row: number, col: number, mapOfBatch: Map<string, Sample>) {
    let positionString = this.getRowColStringFromPos(row, col);
    if (mapOfBatch.has(positionString)) {
      return mapOfBatch.get(positionString);
    }
    let sample = new CovidSamples();
    sample.barcode = '';
    return sample;
  }

  getSampleBackgroudColor(sample: CovidSamples){
    if(!sample || !sample.barcode || sample.barcode===''){
      return {'background-color' : 'white'}
    }
    if(this.isConcentrationHigh(sample)){
      return {'background-color' : 'aqua'}
    }
    return {'background-color' : '#F0CCED'};
  }

  isConcentrationHigh(sample: CovidSamples){
    if(!sample || !sample.sampleQC || sample.sampleQC.length<1){
      this.sampleQCPerformedForSelectedBatch = false
      return false;
    }
    this.sampleQCPerformedForSelectedBatch = true
    if(!sample.sampleQC[sample.sampleQC.length-1].concentration || sample.sampleQC[sample.sampleQC.length-1].concentration.length<1)
      return false;
    if(sample.sampleQC[sample.sampleQC.length-1].concentration.includes('>')){
      return true;
    }
    if(sample.sampleQC[sample.sampleQC.length-1].concentration.includes('?')){
      return true
    }
    let conc : string = sample.sampleQC[sample.sampleQC.length-1].concentration.replace(',', '.');
    let concVal : number = parseFloat(conc)
    return concVal>100;
  }

  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders[row] + this.columnHeaders[col];
  }

  isValidProcessStep(stepName: string): boolean {
    var stepsMap = this.selectedBatchStepsMap;
    return (stepsMap.get(stepName) != undefined && stepsMap.get(stepName) != null);
  }

  getProcessStepStartPuid(stepName: string): string {
    var stepsMap = this.selectedBatchStepsMap;
    return stepsMap.has(stepName) ? stepsMap.get(stepName).startPUID: null;
  }

  getProcessStepEndPuid(stepName: string): string {
    var stepsMap = this.selectedBatchStepsMap;
    return stepsMap.has(stepName) ? stepsMap.get(stepName).endPUID: null;
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    var stepsMap = this.selectedBatchStepsMap;
    return stepsMap.has(stepName) ? stepsMap.get(stepName).startTimeStamp: null;
  }

  getProcessStepEndTimestamp(stepName: string): Date {
    var stepsMap = this.selectedBatchStepsMap;
    return stepsMap.has(stepName) ? stepsMap.get(stepName).endTimeStamp: null;
  }

  calculatingTimes(timeLeftInSecs: number) {
    let timeLeft = Math.floor(timeLeftInSecs);
    if (timeLeft == 0)
      return "00:00:00";
    let sec = 0, min = 0, hr = 0
    if (timeLeft % 60 != 0) {
      sec = timeLeft % 60;
      timeLeft = timeLeft - sec;
    }
    timeLeft = timeLeft / 60;
    if (timeLeft % 60 != 0) {
      min = timeLeft % 60;
      timeLeft = timeLeft - min;
    }
    timeLeft = timeLeft / 60;
    hr = timeLeft;
    let secStr = "00" + sec, minStr = "00" + min, hrStr = "00" + hr
    return hrStr.substring(hrStr.length - 2) + ':' + minStr.substring(minStr.length - 2) + ":" + secStr.substring(secStr.length - 2);
  }

  calculateRemainingTime(actionRunTime: number, actionStartTime: Date) {
    let currentDateLocal = new Date();
    if(actionStartTime.getTime()+actionRunTime*60*1000 <= currentDateLocal.getTime()){
      return 0;
    }
    return (actionStartTime.getTime()+actionRunTime*60*1000 - currentDateLocal.getTime())/1000;
  }

  convertUtcToLocal(date: Date): Date{
    if(!date || date==null) return;
    let offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  puidPopupMethod(status: string) {
    this.enteredPassword = "";
    this.enteredPuid = "";
    this.enteredPasswordToByeArray = [];
    this.puidPopup = true;
    this.puidPopupFunction = status;
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  onFileSelectQPCR(filesData){
    if(this.selectedBatch.libQcMachineType == "QPCR"){
      if(filesData.target.files[0].name.split('.').pop() != "txt"){
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Invalid File Type!!',
          detail: 'Only Text files are allowed.',
        });
        return
      }
      this.maUploadedFile = filesData.target.files[0];
      this.isFileNotSelected = false; 
    }else if(this.selectedBatch.libQcMachineType == "QUBIT"){
      if(filesData.target.files[0].name.split('.').pop() != "csv"){
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Invalid File Type!!',
          detail: 'Only CSV files are allowed.',
        });
        return
      }
      this.maUploadedFile = filesData.target.files[0];
      this.isFileNotSelected = false; 
    }
  }

  onFileSelect(event){
    if(event.target.files[0].name.split('.').pop() != "txt"){
      this.isSampleQCFileNotSelected = true;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only Text files are allowed.',
      });
    }else{
      this.isSampleQCFileNotSelected = false;
    }
  }

  fileUploadQPCROrQubit(fileInput: HTMLInputElement){
    if(this.selectedBatch.libQcMachineType == "QPCR"){
      this.fileUploadQPCR(fileInput)
    }
    else if(this.selectedBatch.libQcMachineType == "QUBIT"){
      this.fileUploadQubit(fileInput)
    }
  }

  fileUploadQubit(fileInput: HTMLInputElement){
    const formData = new FormData();
    formData.append('file', this.maUploadedFile);
    formData.append('batch', this.selectedBatch.batchID);
    formData.append('labId', this.selectedBatch.lab);
    formData.append('puid', this.puid)
    this.blocked = true;
    this.apgTestingService.uploadQubitFile(formData).subscribe(
      result => {
        this.blocked = false;
        fileInput.value = null;
        if (!result) {
          return;
        }
        this.selectedBatch = result.data;
        this.previewComment = this.getPreviewComment(this.selectedBatch);
        this.commentsMap = new Map<string, Comment[]>();
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Upload Successful', detail: 'Q-PCR file has been uploaded successfully' });
        this.validateSampleQC(this.selectedBatch.samples)
        this.isFileNotSelected = true;
        this.manualEXELElement.nativeElement.value = "";
      },
      error => {
        this.blocked = false;
        fileInput.value = null;
        this.isFileNotSelected = true;
        this.manualEXELElement.nativeElement.value = "";
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  fileUploadQPCR(fileInput: HTMLInputElement){
    const formData = new FormData();
    formData.append('file', this.maUploadedFile);
    formData.append('batch', this.selectedBatch.batchID);
    formData.append('labId', this.selectedBatch.lab);
    this.blocked = true;
    this.apgTestingService.uploadFLXFileQPCRBiorad(formData).subscribe(
      result => {
        this.blocked = false;
        fileInput.value = null;
        if (!result) {
          return;
        }
        this.selectedBatch = result.data;
        this.previewComment = this.getPreviewComment(this.selectedBatch);
        this.commentsMap = new Map<string, Comment[]>();
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Upload Successful', detail: 'Q-PCR file has been uploaded successfully' });
        this.validateSampleQC(this.selectedBatch.samples)
        this.isFileNotSelected = true;
        this.manualEXELElement.nativeElement.value = "";
      },
      error => {
        this.blocked = false;
        fileInput.value = null;
        this.isFileNotSelected = true;
        this.manualEXELElement.nativeElement.value = "";
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  fileUpload(fileInput: HTMLInputElement){
    this.selectedBatch.excelUploadCreatedAt = new Date();
    this.selectedBatch.excelUploadCreatedBy = this.puid;
    const formData = new FormData();
    formData.append('file', fileInput.files[0]);
    formData.append('labId', this.selectedLabId);
    formData.append('batchID', this.selectedBatch.batchID);
    formData.append('statusOfTheBatch', this.selectedBatch.statusOfTheBatch);
    formData.append('puid', this.puid);
    formData.append('resultUploaded', this.selectedBatch.statusOfTheBatch == PlateStatus.START_SAMPLE_QC ? this.selectedBatch.sampleQCResultUploaded.toString() : this.selectedBatch.libQCResultUploaded.toString());
    formData.append('diluated', this.dillusionFactorForSampleQC.toString());
    this.blocked = true;
    this.apgTestingService.uploadFLXFile(formData).subscribe(
      result => {
        fileInput.value = null;
        this.isSampleQCFileNotSelected = true;
        if (!result) {
          return;
        }
        this.selectedBatch = result.data;
        this.previewComment = this.getPreviewComment(this.selectedBatch);
        this.commentsMap = new Map<string, Comment[]>();
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Upload Successful', detail: 'FLX file has been uploaded successfully' });
        this.validateSampleQC(this.selectedBatch.samples)
      },
      error => {
        fileInput.value = null;
        this.isSampleQCFileNotSelected = true;
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }
  publishLibrariesForSelectedBatch() {
    if(this.selectedBatch != undefined || this.selectedBatch._id != null) {
      let libraries: Array<Library> = [];
      let batchTagObject = this.mapOfTags.get(this.selectedBatch.tagPlateId)
      for(let i = 0; i < this.selectedBatch.samples.length; i++) {
        if(this.selectedBatch.samples[i].doNotSequence) {
          continue;
        }else {
          let lib = new Library();
          lib.sampleBarcode = this.selectedBatch.samples[i].barcode;
          lib.sequencerType = "NovaSeq";
          lib.readCharecteristics = "PE";
          lib.readLength = 150;
          lib.status = "lib-prep-finished";
          lib.ignoreFromRunPlanning = false;
          lib.jobId = this.selectedBatch.samples[i].barcode;
          lib.sampleName = this.selectedBatch.samples[i].barcode;
          lib.projectId = "Akrivia-01";  //Always Same
          lib.projectName = "Akrivia-01"; //Always Same
          lib.runId = null;
          lib.runMode = "MS PE150"; //From Selection
          lib.plannedReads = this.selectedBatch.requiredRead;
          lib.missingReads = this.selectedBatch.requiredRead;
          lib.samplePosition = this.setPosition(this.selectedBatch.samples[i].positionRow, this.selectedBatch.samples[i].prositionCol)
          lib.plateID = this.selectedBatch.cleanUpPlateID
          lib.tagInfo = [
            {
              "tagSequence": this.selectedBatch.samples[i].u7Sequence + '-' + this.selectedBatch.samples[i].u5Sequence,
              "tagManufacturerindex": batchTagObject[this.getPositionFromRowCol(this.selectedBatch.samples[i].positionRow, ("0" + this.selectedBatch.samples[i].prositionCol).slice(-2))]['tagName'],
              "tagPlatePosStr": this.getPositionFromRowCol(this.selectedBatch.samples[i].positionRow, ("0" + this.selectedBatch.samples[i].prositionCol).slice(-2))
            }
          ];
          let d = new Date();
          lib.dueDate = d.getFullYear().toString() + '-' + (d.getMonth() + 1).toString() + '-' + d.getDate().toString(); // What will be the due date of the libraries
          lib.dueDateRawData = d.getFullYear().toString() + '-' + (d.getMonth() + 1).toString() + '-' + d.getDate().toString(); // What will be the due date of the libraries
          lib.highPriority = this.selectedBatch.rushSample ? "1" : "0";
          lib.constraintType = "independent";
          lib.constraintId = "";
          lib.libraryType = "MBP Illu";
          lib.labName = this.selectedLab.name;
          lib.statusSetTime = d.getMilliseconds().toString();
          libraries.push(lib)
        }
      }
      this.runPlanningService.publishLibrariesFromBatch(libraries, this.selectedLabId).subscribe(
        result => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Libraries Updated!',
            detail: 'Libraries have been updated successfully'
          });
        },
        error => {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Libraries not added!',
            detail: error
          })
        }
      )
    }
  }

  setPosition(row, col){
    return this.rowHeaders[row-1]+this.columnHeaders[col-1]
  }

  validateSampleQC(samples: CovidSamples[]){
    this.plateMap.clear();
    this.samplesWithHighConcentration = []
    let samplesToBeDilutedCount = 0;
    if(samples && samples.length>0){
      samples.forEach(sample => {
        if (sample) {
          let posRow = sample.positionRow96 && sample.positionRow96 != 0 ? sample.positionRow96 : sample.positionRow;
          let posCol = sample.positionRow96 && sample.positionCol96 != 0 ? sample.positionCol96 : sample.prositionCol;
          this.plateMap.set(this.getRowColStringFromPos(posRow - 1, posCol - 1), sample);
          if(this.isConcentrationHigh(sample)){
            this.samplesWithHighConcentration.push(sample);
            samplesToBeDilutedCount++;
          }
        }
      })
      if(samplesToBeDilutedCount>0&&samplesToBeDilutedCount<=10){
        this.sampleQcToBeDiluted = true;
        this.sampleQCDilutionSubHeader = "Dilute the highlighted samples 1:5"
        this.sampleQcPartialReupload = true;
        this.sampleQcCompleteReupload = false;
        return false;
      }else if(samplesToBeDilutedCount>10){
        this.sampleQcToBeDiluted = true;
        this.sampleQCDilutionSubHeader = "Dilute the highlighted samples 1:5 and remeasure the complete plate"
        this.sampleQcPartialReupload = false;
        this.sampleQcCompleteReupload = true;
        return false;
      }
    }
    this.sampleQcToBeDiluted = false;
    return true;
  }

  sampleQcBackToUpload(){
    this.sampleQcToBeDiluted = false;
  }

  sampleQcDownloadFLXWorkFile(){
    this.downloadFLXWorkFile();
    this.sampleQcToBeDiluted = false;
  }

  createDilutedSamples(statusOfBatch: string){
    if(this.selectedBatch != undefined || this.selectedBatch._id != null){
      this.selectedBatch.dilutedSamples = [];
      this.selectedBatch.samples.forEach(value => {
        let dilutedSample = new DilutedCovidSamples();
        dilutedSample.cp = 0.0;
        dilutedSample.parent = value.barcode;

        dilutedSample.barcode = value.barcode+"_d1";
        dilutedSample.positionRow = ((value.positionRow-1)*2)+1;
        dilutedSample.prositionCol = ((value.prositionCol-1)*2)+1;
        dilutedSample.position = this.getPositionFromRowCol(((value.positionRow-1)*2)+1,((value.prositionCol-1)*2)+1);
        this.selectedBatch.dilutedSamples.push(this.clone(dilutedSample));

        dilutedSample.barcode = value.barcode+"_d1_D";
        dilutedSample.prositionCol = ((value.prositionCol)*2);
        dilutedSample.position = this.getPositionFromRowCol(((value.positionRow-1)*2)+1,((value.prositionCol)*2));
        this.selectedBatch.dilutedSamples.push(this.clone(dilutedSample));

        dilutedSample.barcode = value.barcode+"_d2";
        dilutedSample.positionRow = ((value.positionRow)*2);
        dilutedSample.prositionCol = ((value.prositionCol-1)*2)+1;
        dilutedSample.position = this.getPositionFromRowCol(((value.positionRow)*2),((value.prositionCol-1)*2)+1);
        this.selectedBatch.dilutedSamples.push(this.clone(dilutedSample));

        dilutedSample.barcode = value.barcode+"_d2_D";
        dilutedSample.prositionCol = ((value.prositionCol)*2);
        dilutedSample.position = this.getPositionFromRowCol(((value.positionRow)*2),((value.prositionCol)*2));
        this.selectedBatch.dilutedSamples.push(this.clone(dilutedSample));

      });
      let standardValues = this.getStandardValuesForDilutedSamples();
      this.selectedBatch.dilutedSamples = this.selectedBatch.dilutedSamples.concat(this.getStandardValuesForDilutedSamples());
      this.refStatusOfPrev = this.selectedBatch.previousStatusOfTheBatch;
      this.selectedBatch.statusOfTheBatch = statusOfBatch;
      this.selectedBatch.previousStatusOfTheBatch = statusOfBatch;
      this.saveBatchData();
    }
  }

  getPositionFromRowCol(row,col){
    return String.fromCharCode(64+row)+col
  }

  getStandardValuesForDilutedSamples(){
    let standardList: Array<DilutedCovidSamples> = [];
    for(let i=1;i<=6;i++){
      let dilutedSample = new DilutedCovidSamples();
        dilutedSample.cp = 0.0;
        dilutedSample.parent = null;
        dilutedSample.barcode = "S"+i;
        dilutedSample.positionRow = i;
        dilutedSample.prositionCol = 23;
        dilutedSample.position = this.getPositionFromRowCol(i,23);
        standardList.push(this.clone(dilutedSample));

        dilutedSample.prositionCol = 24;
        dilutedSample.position = this.getPositionFromRowCol(i,24);
        standardList.push(this.clone(dilutedSample));
    }

    return standardList;
  }

  downloadNormalizationWorkFile(){
    this.blocked = true;
    this.apgTestingService.downloadNormalizationWorkFile(this.selectedBatch.batchID,this.selectedBatch.lab).subscribe(

        result => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Intiating Normalization workfile download',
            detail: '',
          });
          let txtData = result.data;
          let blobTxt: Blob = new Blob([txtData], { type: 'application/octet-stream' });
          let fileTxt: string = "Normalisation_WorkFile_"+this.selectedBatch.batchID + ".csv"
          saveByFileSaver(blobTxt, fileTxt);
          this.searchForBatchAction(this.selectedBatch.lab,this.selectedBatch.batchID);
          this.blocked = false;

        },
        error => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      )

  }

  downloadCleanUpWorkfile(){
    this.blocked = true;
    this.apgTestingService.downloadCleanUpWorkfile(this.selectedBatch.batchID,this.selectedBatch.lab).subscribe(
        result => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Intiating Normalization workfile download',
            detail: '',
          });
          this.blocked = false;
          let txtData = result.data;
          let blobTxt: Blob = new Blob([txtData], { type: 'application/octet-stream' });
          let fileTxt: string = "Cleanup_WorkFile_"+this.selectedBatch.batchID + ".csv"
          saveByFileSaver(blobTxt, fileTxt);
          this.searchForBatchAction(this.selectedBatch.lab,this.selectedBatch.batchID);
        },
        error => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      )
  }

  checkForAliquotPlateID(){
    if(this.selectedBatch.aliquotPlateID !== this.selectedBatch.batchID+'_A'){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Wrong aliquot plate ID',
        detail: 'Wrong aliquot plate scanned: '+this.selectedBatch.aliquotPlateID+ ' for plate: '+this.selectedBatch.batchID
      })
      this.selectedBatch.aliquotPlateID=''
    }
  }

  checkForNormalizationPlateID(){
    if(this.selectedBatch.normalizationPlateID !== this.selectedBatch.batchID+'_N'){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Wrong normalization plate ID',
        detail: 'Wrong normalization plate scanned: '+this.selectedBatch.normalizationPlateID+ ' for plate: '+this.selectedBatch.batchID
      })
      this.selectedBatch.normalizationPlateID=''
    }
  }

  checkForCleanUpPlateID(){
    if(this.selectedBatch.cleanUpPlateID !== this.selectedBatch.batchID+'_C'){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Wrong cleanUp plate ID',
        detail: 'Wrong cleanUp plate scanned: '+this.selectedBatch.cleanUpPlateID+ ' for plate: '+this.selectedBatch.batchID
      })
      this.selectedBatch.cleanUpPlateID=''
    }
  }

  skipProcessSteps(status: string){
    this.skipProcessStepsPopUp = true;
    this.skipProcessStepsPopUpHeader = status=="GO_TO_TAGMENTATION"?"Go To Tagment.":"Skip Normaliz.";
    this.skipProcessStepsPopUpButtonStatus = status;
    setTimeout( () => {
      this.findAndHighlightElement("normalization-plate-input-field");
    }, 300)
  }

  isQCPRFileUploaded(){
    if(this.selectedBatch.libQcMachineType == "QPCR"){
      if(!this.selectedBatch.samples){
        return false;
      }
      if(this.selectedBatch.samples[0].libConcentration){
        return true
      }
      else{
        return false
      }
    }
    return true
  }


  fetchAllActiveMachines() {
    this.masterDataService.getConfigList(this.selectedLabId, "machine", 0, 1000).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.machinesList = results.data;
        this.machinesList.forEach(machine => {
          this.machinesBarcodeMap.set(machine.barcode, machine);
        })
      }
    )
  }

  checkMachineBarcode() {
    if(this.selectedBatch.libQcMachine.trim() == ""){
      return;
    }
    if (!this.machinesBarcodeMap.has(this.selectedBatch.libQcMachine)) {
      this._messagesService.addErrorMessage({
        severity: "error", summary: "Machine not found!",
        detail: "Machine with barcode " + this.selectedBatch.libQcMachine + " not found. Please check the barcode and scan again."
      })
      this.selectedBatch.libQcMachine = "";
      return;
    }
    let qubitValue = this.machinesBarcodeMap.get(this.selectedBatch.libQcMachine).type.qubit
    let qPcrValue = this.machinesBarcodeMap.get(this.selectedBatch.libQcMachine).type.qPcr
    if (qubitValue == qPcrValue) {
      this._messagesService.addErrorMessage({
        severity: "error", summary: "Barcode is invalid!",
        detail: "Equipment config is incorrect. Please check and update"
      })
      return
    } 
     
    if (this.machinesBarcodeMap.get(this.selectedBatch.libQcMachine).type.qubit) {
      this.selectedBatch.libQcMachineType = "QUBIT"
    } else {
      this.selectedBatch.libQcMachineType = "QPCR"
    }
    
    this.saveBatchData()
  }

  disableQpcrWorkFileButton() {
    if (this.selectedBatch.libQcMachineType && this.selectedBatch.libQcMachineType != "") {
      if (this.selectedBatch.libQcMachineType == "QUBIT") {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  disableCompleLibQCButton() {
    if((!this.selectedBatchStepsMap || this.selectedBatchStepsMap==null || this.selectedBatchStepsMap.size < 1)){
      return true;
    }

    if(!this.selectedBatch.lowMolarity){
      return false;
    }

    for (let i = 0; i < this.selectedBatch.samples.length; i++) {
      if (!this.selectedBatch.samples[i].doNotSequence && !this.selectedBatch.samples[i].allowSequence) {
        return true;
      }
    }
    return false;
  }
}
